<template>
  <div class="pt-4 tabtitle2 bg-white">
    <div class="qna" v-if="assessments.length != 0">
      <QNA />
    </div>
    <!-- <div class="flex py-3 justify-center">
      <div class="mx-2">
        <button
          type="button"
          class="btn btn-outline-secondary  text-black px-8 flex text-md items-center"
        >
          <feather-icon icon="BookOpenIcon" class="mr-2"></feather-icon>Overview
        </button>
      </div>
      <div class="mx-2">
        <button
          type="button"
          class="btn btn-outline-secondary text-black px-8 flex text-md items-center"
        >
          <feather-icon icon="BookIcon" class="mr-2"></feather-icon>Notebook
        </button>
      </div>
    </div>
    <hr /> -->
    <b-tabs content-class="mt-3 " align="center">
      <b-tab title="Overview" active class="tabtitle mt-4">
        <div class="py-8">
          <div class="w-4/5 mx-auto">
            <div class="flex w-full item-center justify-between">
              <div v-if="selectedCourse.live.length > 0">
                <div
                  class="w-full mt-6"
                  v-for="(item, index) in author"
                  :key="index"
                >
                  <div class="flex items-center mt-8">
                    <img
                      :src="$imageURL + '/' + item.profilePhoto"
                      alt=""
                      class="rounded-full w-6 h-6 mr-2"
                      v-if="item.profilePhoto != ''"
                    />
                    <img
                      src="../../img/profile/blank-profile.png"
                      alt=""
                      class="rounded-full w-6 h-6 mr-2"
                      v-else
                    />

                    <p class="text-black font-medium">
                      {{ item.userId.firstname + " " + item.userId.lastname }}
                    </p>
                  </div>
                  <div class="w-full md:pl-4">
                    <!-- <p class="text-black font-medium">
                      {{ item.userId.firstname + " " + item.userId.lastname }}
                    </p> -->
                    <p class="pr-4 lh22px pb-2">
                      {{
                        selectedCourse.live[0].date
                          | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                      }}
                    </p>
                    <!-- <p class="pr-4 lh22px pb-2">
                      {{ selectedCourse.live[0].time }}
                    </p> -->
                    <div class="md:flex">
                      <a
                        :href="selectedCourse.live[0].url"
                        class="underline text-blue cursor-pointer md:text-base text-sm"
                      >
                        {{ selectedCourse.live[0].url }}
                      </a>

                      <!-- <p
                        class="
                          lg:ml-4 lg:mt-0
                          mt-2
                          underline
                          text-blue
                          cursor-pointer
                          md:text-base
                          text-sm
                        "
                        @click="handleOpenLink(twitter)"
                      >
                        Follow on Twitter
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-1/2">
                <p class="font-semibold mb-2">INSTRUCTOR</p>

                <div
                  class="w-full mt-6"
                  v-for="(item, index) in author"
                  :key="index"
                >
                  <div class="flex items-center">
                    <img
                      :src="$imageURL + '/' + item.profilePhoto"
                      alt=""
                      class="rounded-full w-6 h-6 mr-2"
                      v-if="item.profilePhoto != ''"
                    />
                    <img
                      src="../../img/profile/blank-profile.png"
                      alt=""
                      class="rounded-full w-6 h-6 mr-2"
                      v-else
                    />

                    <p class="text-black font-medium">
                      {{ item.userId.firstname + " " + item.userId.lastname }}
                    </p>
                  </div>
                  <div class="w-full md:pl-4">
                    <!-- <p class="text-black font-medium">
                      {{ item.userId.firstname + " " + item.userId.lastname }}
                    </p> -->
                    <p class="pr-4 lh22px pb-2">
                      {{ item.designation }}
                    </p>
                    <div class="md:flex">
                      <p
                        class="underline text-blue cursor-pointer md:text-base text-sm"
                        @click="handleOpenLink(linkedin)"
                      >
                        View on LinkedIn
                      </p>

                      <p
                        class="lg:ml-4 lg:mt-0 mt-2 underline text-blue cursor-pointer md:text-base text-sm"
                        @click="handleOpenLink(twitter)"
                      >
                        Follow on Twitter
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vl"></div>
              <div class="w-1/2 pl-6">
                <p class="font-semibold">RELATED TO THIS COURSE</p>
                <ul class="mt-6">
                  <!-- <li class="flex my-4">
                    <feather-icon
                      icon="UsersIcon"
                      class="cursor-pointer"
                    ></feather-icon>
                    <span class="ml-2 text-black">Learning Groups</span>
                  </li> -->
                  <li class="flex my-4">
                    <feather-icon
                      icon="FileIcon"
                      class="cursor-pointer"
                      svgClasses="lg:w-6 lg:h-6 w-5 h-5"
                    ></feather-icon>
                    <span class="ml-2 text-black">Exercise Files</span>
                  </li>
                  <li class="flex my-4">
                    <feather-icon
                      icon="ThumbsUpIcon"
                      class="cursor-pointer"
                      svgClasses="lg:w-6 lg:h-6 w-5 h-5"
                    ></feather-icon>
                    <span class="ml-2 text-black text-base">Certificates</span>
                  </li>
                  <!-- <li class="flex my-4">
                    <feather-icon
                      icon="GridIcon"
                      class="cursor-pointer"
                    ></feather-icon>
                    <span class="ml-2 text-black"
                      >Continuing Education Units</span
                    >
                  </li> -->
                  <!-- <li class="flex my-4">
                    <feather-icon
                      icon="EditIcon"
                      class="cursor-pointer"
                    ></feather-icon>
                    <span class="ml-2 text-black">Exam</span>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- <div class="py-8">
              <p class="text-xl text-black font-semibold pb-2">Live Session</p>
              <div v-for="item in selectedCourse.live" :key="item._id">
                <span class="" @click="open(item.url)"> {{ item.name }}</span
                >&nbsp;&nbsp;

                <span class="">
                  Date:
                  {{ new Date(item.date).toDateString() }}</span
                >&nbsp;&nbsp;
                <span class=""> Time:{{ item.time }} </span>&nbsp;&nbsp;
              </div>
            </div> -->
            <div class="py-8">
              <p class="text-xl text-black font-semibold pb-2">
                Course details
              </p>
              <span class="">{{ selectedCourse.duration }}hrs </span
              >&nbsp;&nbsp;
              <span class=""> {{ selectedCourse.level }} </span>&nbsp;&nbsp;
              <span class="">
                Released:
                {{
                  new Date(selectedCourse.createdBy.date).toDateString()
                }}</span
              >
              <!-- <div class="flex pt-1">
                <img src="@/assets/images/customer-view/rating.png" />
              </div> -->
              <p class="pt-4">
                <!-- Learn how to promote your business effectively online and
                develop a targeted online marketing strategy that engages
                potential customers throughout the digital landscape. In this
                course, Brad Batesole explains today's digital marketing
                techniques in simple terms, demonstrating how to build a
                successful online marketing campaign for all digital channels:
                search, video, social, email, and display. -->
                {{ selectedCourse.description }}
              </p>
              <p class="pt-4">
                <!-- Brad shows how to evaluate your website and identify conversion
                goals, measure and interpret website analytics, get the most out
                of SEO, and set up your first text and display ads. See how to
                connect with communities on the leading social networks, learn
                best practices for developing and distributing video marketing
                content, and find out what makes an email marketing campaign
                successful. This course also covers content marketing, mobile
                marketing, and influencer marketing, as well as recommendations
                for expanding your digital marketing skillset. Upon completing
                this foundational digital marketing course, you'll be equipped
                with skills and strategies that can help you navigate today's
                online landscape and develop a smart plan of action. -->
                {{ selectedCourse.coursefor.toString() }}
              </p>
            </div>
            <div>
              <p class="text-xl text-black font-semibold">
                Learning objectives
              </p>
              <p class="obje mt-2" v-html="selectedCourse.content"></p>
              <!-- <ul class="pt-4 obje ml-4">
                <li>
                  Examine the importance of the top three digital strategies for
                  business, brand, and marketing.
                </li>
                <li>Define vital online marketing terms.</li>
                <li>
                  Explore the components of the digital marketing landscape.
                </li>
                <li>Identify the uses of a marketing funnel.</li>
                <li>Discover the characteristics of an effective website.</li>
                <li>
                  Recognize the importance behind choosing an effective domain
                  name.
                </li>
                <li>
                  Determine the importance of choosing a responsive design.
                </li>
                <li>Examine the fundamentals of a conversion funnel.</li>
              </ul> -->
            </div>
            <!-- <div class="py-8">
              <p class="text-xl text-black font-semibold pb-4">
                Skills covered
              </p>
              <span class="badge badge-pill badge-default px-6 py-2"
                >Online Marketing</span
              >
            </div> -->
            <!-- <div class="">
              <p class="text-xl text-black font-semibold pb-4">Learners</p>
              <div class="flex">
                <div class="avatar-group">
                  <a
                    href="#"
                    class="avatar avatar-sm rounded-circle"
                    data-toggle="tooltip"
                    data-original-title="Ryan Tompson"
                  >
                    <img
                      alt="Image placeholder"
                      src="@/assets/images/customer-view/std.jpg"
                    />
                  </a>
                  <a
                    href="#"
                    class="avatar avatar-sm rounded-circle"
                    data-toggle="tooltip"
                    data-original-title="Romina Hadid"
                  >
                    <img
                      alt="Image placeholder"
                      src="@/assets/images/customer-view/std.jpg"
                    />
                  </a>
                  <a
                    href="#"
                    class="avatar avatar-sm rounded-circle"
                    data-toggle="tooltip"
                    data-original-title="Alexander Smith"
                  >
                    <img
                      alt="Image placeholder"
                      src="@/assets/images/customer-view/std.jpg"
                    />
                  </a>
                </div>
                <div class="ml-4">
                  <p class="text-blue underline">
                    23,690 members like this content
                  </p>
                </div>
                <div class="ml-4">
                  <p class="text-blue underline">
                    392,507 people started learning
                  </p>
                </div>
              </div>
            </div> -->
          </div>
        </div></b-tab
      >
      <b-tab title="Discussion">
        <div class="py-8">
          <div class="w-4/5 mx-auto">
            <!-- <div>
              <b-form-textarea
                id="textarea-rows"
                placeholder="Type your note here to save for later..."
                rows="6"
              ></b-form-textarea>
              <div class="flex justify-between">
                <p>0 Notes taken</p>
                <p>Press Enter to save</p>
              </div>
            </div>
            <div class="mt-8">
              <div class="bg-grey3 p-1.5 flex justify-between">
                <p class="font-semibold text-md text-black ml-2">
                  Introduction
                </p>
                <feather-icon
                  icon="ChevronDownIcon"
                  class="mr-2 my-auto"
                ></feather-icon>
              </div>
              <div class="mt-4">
                <div class="flex ml-2">
                  <feather-icon
                    icon="PlayIcon"
                    class="mr-2 my-auto text-blue playicon-custom"
                  ></feather-icon>
                  <p class="text-blue font-semibold ">
                    Python Object and Data Structure Basics (02.01)
                  </p>
                </div>
                <p class="pl-8">Note will be added here</p>
                <div class="flex justify-end my-4">
                  <p>Edit</p>
                  <p class="mx-4">|</p>
                  <p>Delete</p>
                </div>
                <hr />
              </div>
            </div>
            <div class="mt-4">
              <div class="bg-grey3 p-1.5 flex justify-between">
                <p class="font-semibold text-md text-black ml-2">
                  Different Applications where Python is used
                </p>
                <feather-icon
                  icon="ChevronDownIcon"
                  class="mr-2 my-auto"
                ></feather-icon>
              </div>
              <div class="mt-4">
                <div class="flex ml-2">
                  <feather-icon
                    icon="PlayIcon"
                    class="mr-2 my-auto text-blue playicon-custom"
                  ></feather-icon>
                  <p class="text-blue font-semibold ">
                    The importance of defining three strategies (17.01)
                  </p>
                </div>
                <p class="pl-8">Note will be added here</p>
                <div class="flex justify-end my-4">
                  <p>Edit</p>
                  <p class="mx-4">|</p>
                  <p>Delete</p>
                </div>
                <hr />
              </div>
            </div>
            <div class="mt-8 text-center">
              <div class="w-1/4 mx-auto">
                <img src="@/assets/images/customer-view/chill.png" class="" />
              </div>
              <p class="text-lg text-black font-medium mt-2">
                No notes saved yet
              </p>
              <p class="">Take notes to remember what you learned!</p>
            </div> -->
            <div class="md:flex items-end">
              <div class="flex w-full">
                <div v-if="userData.userImage" class="mr-2">
                  <img
                    :src="`${$imageURL + '/' + userData.userImage}`"
                    alt=""
                    class="rounded-full md:w-14 md:h-14 w-10 h-10"
                  />
                </div>
                <div v-else class="mr-2">
                  <img
                    src="@/assets/images/customer-view/std.jpg"
                    alt=""
                    class="rounded-full md:w-14 md:h-14 w-10 h-10"
                  />
                </div>
                <div class="lg:w-10/12 w-full">
                  <b-form-textarea
                    id="textarea-rows"
                    placeholder="Type your note here to save for later..."
                    rows="6"
                    class="w-full"
                    v-model="comment"
                  ></b-form-textarea>
                </div>
              </div>
              <div
                class="lg:w-1/12 md:w-1/5 md:mt-0 mt-4 w-full flex justify-end lg:block"
              >
                <p class="btn btn-success cursor-pointer" @click="addComment()">
                  Post
                </p>
              </div>
            </div>

            <div
              class="flex pt-12"
              v-for="(item, index) in comments"
              :key="index"
            >
              <div v-if="item._user.userImage" class="mr-2">
                <img
                  :src="`${$imageURL + '/' + item._user.userImage}`"
                  alt=""
                  class="rounded-full md:w-12 md:h-12 w-10 h-10"
                />
              </div>
              <div v-else class="mr-2">
                <img
                  src="@/assets/images/customer-view/std.jpg"
                  alt=""
                  class="rounded-full md:w-12 md:h-12 w-10 h-10"
                />
              </div>

              <div class="w-11/12">
                <div>
                  <p
                    class="font-semibold text-black text-lg"
                    v-if="item._user != null"
                  >
                    {{ item._user.firstname + " " + item._user.lastname }}
                  </p>
                  <p class="text-xs clr777 font-normal">
                    <!-- {{ new Date(item.createdBy.date).toDateString() }} -->
                  </p>
                  <p class="pt-3 text-black text-base font-normal replycom">
                    {{ item.comment }}
                  </p>
                  <div class="pt-2 flex">
                    <div class="flex items-center">
                      <feather-icon
                        icon="ThumbsUpIcon"
                        class="mr-2 clr830c81"
                        svgClasses="w-4 h-4"
                        id="icon1"
                      ></feather-icon>

                      <p
                        class="text-sm font-semibold clr830c81 cursor-pointer"
                        @click="like(item)"
                      >
                        Helpful ({{ item.totalLikes }})
                      </p>
                    </div>
                    <div class="ml-8">
                      <p
                        class="text-sm font-semibold clr830c81 cursor-pointer"
                        @click="item.showReply = true"
                      >
                        Reply ({{ item.totalReplies }})
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="item.showReply">
                  <div
                    class="flex pt-10"
                    v-for="(items, index) in item.replies"
                    :key="index"
                  >
                    <div class="mr-2">
                      <img
                        src="@/assets/images/customer-view/std.jpg"
                        alt=""
                        class="rounded-full md:w-10 md:h-10 w-10 h-10"
                      />
                    </div>
                    <div class="w-11/12">
                      <div>
                        <p class="font-semibold text-black text-lg">
                          {{
                            items._user.firstname + " " + items._user.lastname
                          }}
                        </p>
                        <!-- {{ new Date(items.createdBy.date).toDateString() }} -->
                        <p class="text-xs clr777 font-normal"></p>
                        <p
                          class="pt-3 text-black text-base font-normal replycom"
                        >
                          {{ items.comment }}
                        </p>
                        <div class="pt-2 flex">
                          <div class="flex items-center">
                            <feather-icon
                              icon="ThumbsUpIcon"
                              class="mr-2 clr830c81"
                              id="icon2"
                              svgClasses="w-4 h-4"
                            ></feather-icon>
                            <p
                              class="text-sm font-semibold clr830c81 cursor-pointer"
                              @click="handleLike(items)"
                            >
                              Helpful ({{ items.totalLikes }})
                            </p>
                          </div>
                          <!-- <div class="ml-8">
                            <p
                              class="text-base font-semibold clr830c81 cursor-pointer"
                            >
                              Reply ({{ items.totalReplies }})
                            </p>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="md:flex md:items-end pt-10">
                    <div class="flex items-start md:w-4/5">
                      <div class="mr-2">
                        <img
                          src="@/assets/images/customer-view/std.jpg"
                          alt=""
                          class="rounded-full md:w-10 md:h-10 w-10 h-10"
                        />
                      </div>
                      <div class="lg:w-10/12 w-full">
                        <b-form-textarea
                          id="textarea-rows"
                          placeholder="Type your note here to save for later..."
                          rows="4"
                          class="w-full"
                          v-model="reply"
                        ></b-form-textarea>
                      </div>
                    </div>

                    <div
                      class="lg:w-1/12 md:w-1/5 md:mt-0 mt-4 w-full flex justify-end lg:block lg:ml-4 ml-0"
                    >
                      <p
                        class="btn btn-success cursor-pointer"
                        @click="addReply(item)"
                      >
                        Post
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="flex pt-8">
              <div class="w-1/12">
                <div class="w-full"></div>
              </div>
              <div class="11/12">
                <div class="w-full flex">
                  <div class="w-1/12">
                    <img
                      src="@/assets/images/customer-view/std.jpg"
                      alt=""
                      class="rounded-full w-14 h-14"
                    />
                  </div>
                  <div class="w-11/12">
                    <div>
                      <p class="font-semibold text-black text-lg">
                        Sumit Jaiswal
                      </p>
                      <p class="text-xs clr777 font-normal">27 Aug 2021</p>
                      <p class="pt-3 text-black text-base font-normal">
                        Lorem ipsum dolor sit amet. Vel totam reprehenderit ea
                        reiciendis labore a illum voluptatem quo atque culpa est
                        velit tempora ut animi quia? Ut tempore fugiat At
                        architecto sapiente et perspiciatis praesentium in
                        consequatur officiis qui ullam omnis At repellendus
                        sapiente. Ab blanditiis quia quo officia perferendis vel
                        quisquam animi.
                      </p>
                      <div class="pt-2 flex">
                        <div class="flex items-center">
                          <feather-icon
                            icon="ThumbsUpIcon"
                            class="mr-2 clr830c81"
                          ></feather-icon>
                          <p class="text-base font-semibold clr830c81">
                            Helpful (0)
                          </p>
                        </div>
                        <div class="ml-8">
                          <p class="text-base font-semibold clr830c81">
                            Reply (0)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import QNA from "./QnAScreen.vue";
export default {
  components: {
    QNA,
  },
  data() {
    return {
      author: [],
      links: {},
      linkedin: "",
      twitter: "",
      youtube: "",
      facebook: "",
      comment: "",
      reply: "",
      comments: [],
      showReply: false,
    };
  },
  props: {
    selectedCourse: Object,
  },
  methods: {
    // open(item) {
    //   window.open(item);
    // },
    Course() {
      // console.log(this.selectedCourse);
      // console.log(this.userData._id);
      this.author = this.selectedCourse.author;

      this.author.map(
        (data) =>
          (this.links = {
            linkedin: data.linkedin,
            twitter: data.twitter,
          })
      );
      // console.log(this.links);
    },

    verifyLink() {
      if (
        this.links.linkedin.includes("https://") ||
        this.links.twitter.includes("https://")
      ) {
        this.linkedin = this.links.linkedin;
        this.twitter = this.links.twitter;
      } else {
        this.linkedin = "https://" + this.links.linkedin;
        this.twitter = "https://" + this.links.twitter;
      }
    },
    handleOpenLink(link) {
      // console.log(link);
      window.open(link, "_blank");
    },
    async getComments() {
      const { data } = await this.$store.dispatch("eLearning/getComments", {
        _id: this.selectedCourse._id,
      });

      this.comments = data[0].comments.map((x) => ({
        ...x,
        showReply: false,
      }));
      // console.log("comments", this.comments);
    },
    async addComment() {
      const data = await this.$store.dispatch("eLearning/addComment", {
        courseId: this.selectedCourse._id,
        comment: this.comment,
      });
      // console.log(data);
      if (data.code == 200) {
        this.$swal.fire({
          title: "Added",

          text: "Comment has been Added Successfully!",

          icon: "success",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.comment = "";
        await this.getComments();
      }
    },
    async addReply(item) {
      // console.log(item);
      const data = await this.$store.dispatch("eLearning/addReply", {
        courseId: this.selectedCourse._id,
        commentId: item._id,
        comment: this.reply,
      });
      if (data.code == 200) {
        this.$swal.fire({
          title: "Added",

          text: "Comment has been Added Successfully!",

          icon: "success",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.reply = "";
        await this.getComments();
      }
    },
    async like(item) {
      // console.log(item.parentId);
      let user = item.likes.filter((x) => x._user == this.userData._id);
      if (user.length == 0) {
        const data = await this.$store.dispatch("eLearning/like", {
          type: "like",
          commentId: item._id,
        });

        if (data.code == 200) {
          await this.getComments();
        }
      } else {
        // console.log("unlike");
        const data = await this.$store.dispatch("eLearning/unlike", {
          commentId: item._id,
        });

        if (data.code == 200) {
          await this.getComments();
        }
      }
    },
    async handleLike(items) {
      let user = items.likes.filter((x) => x._user == this.userData._id);
      // console.log(user);
      if (user.length == 0) {
        const data = await this.$store.dispatch("eLearning/like", {
          type: "like",
          commentId: items._id,
        });

        if (data.code == 200) {
          await this.getComments();
        }
      } else {
        const data = await this.$store.dispatch("eLearning/unlike", {
          commentId: items._id,
        });

        if (data.code == 200) {
          await this.getComments();
        }
      }
    },
  },
  mounted() {
    this.Course();
    this.verifyLink();
    this.getComments();
  },
  computed: {
    ...mapState("auth", ["userData"]),

    ...mapState("eLearning", ["assessments"]),
  },
};
</script>

<style>
ul.obje {
  list-style-type: square;
}
.obje > ol {
  list-style-type: decimal;
}
.obje > ul {
  list-style-type: square;
}
</style>
